'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('jquery-ui/ui/position');

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _config = require('rp-mq-breakpoints/lib/config');

var _scrollTop = require('./utils/scrollTop');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Modal dropdown plugin for RacingPost
 * @copyright Racingpost 2014
 */

var BREAKPOINT_MEDIUM_MIN = _config.config.filter(function (br) {
    return br.code === _config.breakpointCodes.MEDIUM;
})[0].min;

/**
 * Plugin  constructor
 * @param {object} el Dom element object
 * @param {object} options = {
     *      content: {string|object} URL to load in iframe, plain text or jQuery object
     *
     *      width: {string} Valid iframe size string
     *
     *      autoOpen: {boolean} Open dropdown after initialisation
     *
     *      autoScroll: {boolean} Automatically scrolls document to the top
     *
     *      autoLoad: {boolean} Load content right after after initialisation
     *
     *      autoSize: {boolean} In case of url content, trying to adjust iframe height
     *          based on messages sent by target frame
     *
     *      resetOnClose: {boolean} Empty content after close. Content will be requested again on next open
     *
     *      fade: {boolean} Use backdrop
     *
     *      backdropParent: {string} CSS selector or jQuery object to define backdrop parent element
     *
     *      position: {string|object} Frame position relative to element.
     *          Use next values: right|center|left or valid object for jquery.position plugin.
     *          Default is center
     *
     *      arrowPosition: {string} Arrow position auto|right|righter|center|lefter|left.
     *          Default is auto
     *
     *      cssClass: {string} Additional css classes applied to dropdown
     *
     *      openedCssClass {string} Additional css classes applied to element when dropdown is open
     *  }}
 *
 * @constructor
 */
function RpModalDropDown(el, options) {
    this._uniqueId = this.constructor.uniqueId++;
    /**
     * @type {jQuery} Target DOM element
     * @private
     */
    this._element = (0, _jquery2.default)(el);
    /**
     * @type {jQuery} Dropdown DOM element
     * @private
     */
    this._dropdown = null;
    /**
     * @type {object} Position cache
     * @private
     */
    this._position = null;
    /**
     * @type {boolean} TRUE if dropdown is open FALSE otherwise
     * @private
     */
    this._opened = false;
    /**
     * @type {boolean} TRUE if content was loaded FALSE otherwise
     * @private
     */
    this._loaded = false;

    /**
     * Iframe
     * @type {null}
     * @private
     */
    this._iframe = null;
    /**
     * @type {object} Plugin settings
     * @private
     */
    this._options = _jquery2.default.extend({
        id: '',
        content: '',
        autoOpen: true,
        autoScroll: false,
        autoLoad: false,
        autoSize: true,
        resetOnClose: false,
        backdropParent: 'body',
        backdropFrom: '',
        width: '',
        fade: true,
        position: 'center',
        origin: '',
        cssClass: '',
        openedCssClass: '',
        tmpl: '',
        backdrop: '',
        iframeCssClass: '',
        spinnerContainerClass: ''
    }, options);

    this._init();
}

/**
 * Plugin identifier
 * @type {string}
 */
RpModalDropDown.pluginName = 'RpModalDropDown';

/**
 * @type {RpModalDropDown}
 */
RpModalDropDown.opened = null;

/**
 *
 */
RpModalDropDown.uniqueId = 1;

/**
 * Plugin events
 * @type {object}
 */
RpModalDropDown.event = {
    ns: '.modalDropdown',
    show: 'show',
    shown: 'shown',
    hide: 'hide',
    hidden: 'hidden',
    load: 'loading',
    loaded: 'loaded',
    reset: 'reset',
    contentLoaded: 'contentLoaded',
    contentResized: 'contentResized',
    breakpoint: 'breakpoint'
};

/**
 * Plugin css classes
 * @type {object}
 */
RpModalDropDown.css = {
    container: 'ui-popover',
    backdrop: 'ui-overlay',
    opened: ''
};

/**
 * Initialise plugin
 * @private
 */
RpModalDropDown.prototype._init = function () {
    this._dropdown = (0, _jquery2.default)('<div style="display: none"></div>');
    this._dropdown.append(this._options.tmpl);

    this._dropdown.attr('id', this._options.id).css('width', this._options.width).addClass(this.constructor.css.container).addClass(this._options.cssClass);

    (0, _jquery2.default)('body').append(this._dropdown);

    this._unbindEvents();
    this._bindEvents();

    this._options.autoOpen && this.open();
    this._options.autoLoad && this._load();
};

RpModalDropDown.prototype._eventNs = function () {
    var id = this._options.id ? this._options.id : this._uniqueId;
    return this.constructor.event.ns + '-' + id;
};
/**
 *
 */
RpModalDropDown.prototype._eventName = function (eventName) {
    return eventName + this._eventNs();
};

/**
 * Bind default events
 * @private
 */
RpModalDropDown.prototype._bindEvents = function () {
    var self = this;

    (0, _jquery2.default)(document).on(this._eventName('click') + ' ' + this._eventName('touchstart'), (0, _throttle2.default)(function (event) {
        var isElementEvent = self._element.get(0) === event.target || self._element.has(event.target).length;
        var isDropdownEvent = self._dropdown.get(0) === event.target || self._dropdown.has(event.target).length;

        if (isElementEvent) {
            if (!self._opened) {
                self.open();
            } else {
                self.close();
            }

            return false;
        }

        if (self._opened && !isDropdownEvent) {
            self.close();
        }

        return true;
    }, 300, { leading: true, trailing: false }));

    if (this._options.spinnerContainerClass) {
        this._element.bind(this._eventName(this.constructor.event.load), function () {
            var innerDiv = (0, _jquery2.default)('<div/>');
            innerDiv.addClass(self._options.spinnerContainerClass);

            self._dropdown.append(innerDiv);
            innerDiv.append('<svg class="ui-icon ui-icon_size2XL ui-animation_spinnerAnimation"><use xlink:href="img/icons.svg#icon-spinner"></use></svg>');
        });
    }

    this._element.bind(this._eventName(this.constructor.event.loaded), function () {
        if (self._iframe) {
            self._iframe[0].contentWindow.postMessage({
                event: self._eventName(self.constructor.event.breakpoint),
                breakpoint: _rpMqBreakpoints2.default.current()
            }, '*');
        }

        (0, _jquery2.default)(window).bind('rpBreakpointsSwitch', { context: self }, self._onBreakpoint);

        if (self._options.spinnerContainerClass) {
            self._dropdown.find('.' + self._options.spinnerContainerClass).remove();
        }
    });

    var prevOffset = self._element.offset();
    setInterval(function () {
        var currOffset = self._element.offset();

        if (!self._opened || currOffset.top === prevOffset.top && currOffset.left === prevOffset.left) {
            return;
        }
        prevOffset = currOffset;

        self._place();
    }, 100);

    if (self._options.backdropFrom) {
        (0, _jquery2.default)(window).on(this._eventName('scroll'), function () {
            if (!self._opened) {
                return;
            }

            (0, _jquery2.default)('#overlay').position({
                my: 'left top',
                at: 'left bottom',
                of: (0, _jquery2.default)(self._options.backdropFrom).eq(0)
            });
        });
    }
};

RpModalDropDown.prototype._onBreakpoint = function (event) {
    var self = event.data.context;
    if (!self._iframe) {
        return;
    }

    self._iframe[0].contentWindow.postMessage({
        event: self._eventName(self.constructor.event.breakpoint),
        breakpoint: event.detail.breakpoint
    }, '*');
};

/**
 * Unbind events for initialisation or destruction
 * @private
 */
RpModalDropDown.prototype._unbindEvents = function () {
    this._element.unbind(this._eventNs());
    (0, _jquery2.default)(window).unbind(this._eventNs());
    (0, _jquery2.default)(window).unbind('switch.rp.breakpoint', '', this._onBreakpoint);
    (0, _jquery2.default)(document).unbind(this._eventNs());
};

/**
 * Appends backdrop
 * @private
 */
RpModalDropDown.prototype._fade = function () {
    var parent = (0, _jquery2.default)(this._options.backdropParent);
    if (parent.find('#overlay').size()) {
        return;
    }

    var fade = (0, _jquery2.default)('<div id="overlay" />');
    fade.addClass(this.constructor.css.backdrop).addClass(this._options.backdrop);
    parent.append(fade);
};

/**
 * Removes backdrop
 * @private
 */
RpModalDropDown.prototype._unfade = function () {
    (0, _jquery2.default)('#overlay').remove();
};

/**
 * Loads dropdown content
 * @private
 */
RpModalDropDown.prototype._load = function () {
    if (this._loaded) {
        return;
    }

    this._loaded = true;
    var container = this._dropdown;

    this._element.trigger(this._eventName(this.constructor.event.load));
    if (/^(https?:)?\/\//.test(this._options.content)) {
        this._iframe = this._initIframe();
        this._iframe.attr('src', this._options.content);
    } else {
        container.append(this._options.content);
        this._element.trigger(this._eventName(this.constructor.event.loaded));
    }
};

/**
 * Sent message to refresh iframe
 */
RpModalDropDown.prototype._refresh = function () {
    if (this._iframe) {
        this._iframe[0].contentWindow.postMessage('refresh.rp.modalDropdown', '*');
    }
};

/**
 * Performs positioning of dropdown
 * @private
 */
RpModalDropDown.prototype._place = function () {
    var position, my, at;

    if (this._position === null) {
        position = this._options.position;

        if (typeof position === 'string') {
            my = position + ' top';
            at = position + ' bottom+14';
            position = { my: my, at: at };
        }

        if (!position.of) {
            position.of = this._element;
        }

        this._position = position;

        if (this._options.origin) {
            this._dropdown.addClass(this._options.origin);
        }
    }

    this._dropdown.position(this._position);
    if (this._options.backdropFrom) {
        (0, _jquery2.default)('#overlay').position({
            my: 'left top',
            at: 'left bottom',
            of: (0, _jquery2.default)(this._options.backdropFrom).eq(0)
        });
    }

    if (_rpMqBreakpoints2.default.current().min < BREAKPOINT_MEDIUM_MIN) {
        if (!this._options.keepVertically) {
            this._dropdown.css('top', '');
        }

        if (!this._options.keepHorizontally) {
            this._dropdown.css('left', '');
        }
    }
};

/**
 * Initialises iframe and binds default events
 * Frame src will not be set
 *
 * @returns {HTMLElement} Initialised iframe jQuery object
 * @private
 */
RpModalDropDown.prototype._initIframe = function () {
    var self = this;
    var iframe = (0, _jquery2.default)('<iframe width="100%" frameborder="0" scrolling="no" style="display: none" />');
    iframe.addClass(this._options.iframeCssClass);

    iframe.load(function () {
        self._refresh();
    });

    var container = this._dropdown;

    if (this._options.id) {
        iframe.attr('id', this._options.id + '-frame');
    }

    iframe.appendTo(container);

    this._element.bind(this._eventName(this.constructor.event.contentLoaded), function (e, data, iframe) {
        iframe.show();
        self._element.trigger(self._eventName(self.constructor.event.loaded));
        self._element.trigger(self._eventName(self.constructor.event.contentResized), [data, iframe]);
    });

    this._options.autoSize && this._element.bind(this._eventName(this.constructor.event.contentResized), function (e, data, iframe) {
        iframe.height(data.contentHeight);
    });

    window.addEventListener('message', function (event) {
        var eventName = event.data.name;
        if (!eventName) {
            return;
        }

        var ns = '.' + eventName.split('.')[1];
        if (ns !== self._eventNs()) {
            return;
        }

        self._element.trigger(eventName, [event.data, iframe]);
    });

    return iframe;
};

/**
 * Reset dropdown content
 */
RpModalDropDown.prototype.reset = function () {
    this._loaded = false;
    this._dropdown.empty();

    this._element.trigger(this._eventName(this.constructor.event.reset));
};

/**
 * Open dropdown
 */
RpModalDropDown.prototype.open = function () {
    var _this = this;

    if (this._opened) {
        return;
    }

    if (this._options.autoScroll) {
        (0, _scrollTop.scrollTop)();
    }

    setTimeout(function () {
        _this._opened = true;
    }, 100);

    if (this.constructor.opened) {
        this.constructor.opened.close();
    }

    this.constructor.opened = this;

    if (!this._loaded) {
        this._load();
    } else {
        this._refresh();
    }

    this._element.trigger(this._eventName(this.constructor.event.show));

    this._options.fade && this._fade();
    this._dropdown.show();
    this._place();
    this._element.addClass(this.constructor.css.opened).addClass(this._options.openedCssClass);

    this._opened = true;
    this._element.trigger(this._eventName(this.constructor.event.shown));
};

/**
 * Close dropdown
 */
RpModalDropDown.prototype.close = function () {
    var _this2 = this;

    if (!this._opened) {
        return;
    }
    setTimeout(function () {
        _this2._opened = false;
    }, 100);

    this._element.trigger(this._eventName(this.constructor.event.hide));

    this._options.fade && this._unfade();
    this._dropdown.removeAttr('style');
    this._dropdown.hide();
    this._element.removeClass(this.constructor.css.opened).removeClass(this._options.openedCssClass);

    this._opened = false;
    this.constructor.opened = null;

    this._element.trigger(this._eventName(this.constructor.event.hidden));

    if (this._options.resetOnClose) {
        this.reset();
    }
};

/**
 * Toggle dropdown
 */
RpModalDropDown.prototype.toggle = function () {
    this._opened ? this.close() : this.open();
};

/**
 * Destroy dropdown plugin
 */
RpModalDropDown.prototype.destroy = function () {
    this.close();

    this._unbindEvents();

    _jquery2.default.data(this._element, this.constructor.pluginName, undefined);
};

exports.default = RpModalDropDown;


//////////////////
// WEBPACK FOOTER
// ./~/rp-jquery-modal-dropdown/lib/rpModalDropDown.js
// module id = 1393
// module chunks = 1